'use client'
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/hooks/useQueue.ts
import { useCallback, useEffect, useMemo, useState } from "react";
import { readCookie } from "@wbk/utils";
import { useRouter } from "@wbk/config";
var timeout;
var useQueue = ({ autoRefresh } = {}) => {
  const { baseUrl } = useRouter();
  const [queue, setQueue] = useState();
  const [shouldWaitQueue, setShouldWaitQueue] = useState(true);
  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const slug = pathname.split("/").slice(-1).join("");
  const inititeQueue = useCallback(() => __async(void 0, null, function* () {
    try {
      const segmentsArr = pathname.split("/") || [];
      const isBook = pathname.includes("/book");
      const segments = isBook ? segmentsArr.slice(-3, -1) : segmentsArr.slice(-2);
      const base = (baseUrl == null ? void 0 : baseUrl.startsWith("/")) ? baseUrl.slice(1) : baseUrl;
      const folder = base ? `-${base}` : "";
      let cookie = readCookie(`queueData_q_session_${folder}-${segments.join("-")}`);
      if (!cookie) {
        cookie = readCookie(`queueData_q_session_-${segments.join("-")}-book`);
      }
      const queueData = cookie ? JSON.parse(decodeURIComponent(cookie)) : null;
      if (queueData) {
        setQueue(queueData);
      }
    } catch (error) {
      return null;
    } finally {
      setShouldWaitQueue(false);
    }
  }), [baseUrl, pathname]);
  useEffect(() => {
    inititeQueue();
  }, [inititeQueue]);
  const isActive = useMemo(() => {
    return (queue == null ? void 0 : queue.Queued) === "yes" && queue.WaitingNumber > 0;
  }, [queue == null ? void 0 : queue.Queued, queue == null ? void 0 : queue.WaitingNumber]);
  useEffect(() => {
    if (isActive && autoRefresh) {
      const refreshEvery = 6e4;
      timeout = setTimeout(() => {
        window.location.reload();
      }, refreshEvery);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [autoRefresh, isActive]);
  return {
    shouldWaitQueue,
    isActive,
    queue,
    slug
  };
};

export {
  useQueue
};
//# sourceMappingURL=chunk-7VQNZZGN.mjs.map